import React, { useEffect, useState } from 'react';
import SportSelector from '../../common/SportSelector';
import EventsScroller from './EventsScroller';
import ScrollerEvent from './ScrollerEvent';
import Event from './Event';
import EventFetcher from '../event/EventFetcher';
import { openModal } from '../../common/ModalContainer';
import Modal from '../../common/Modal';
import InfoMessage from '../../common/InfoMessage';
import EventError from './EventError';
import Loader from '../../common/Loader';
import LiveTrackerSelector from './LiveTrackerSelector';
import LiveTracker from '../../common/live-tracker/LiveTracker';
import LiveTrackerContainer from './LiveTrackerContainer';
import WidgetContextProvider from '../../WidgetContextProvider';
import StreamingProvider from '../../common/live-tracker/StreamingProvider';
import LiveResults from '../../common/live-search/LiveResults';
import MultiliveStreaming from './MultiliveStreaming';

export default function Multilive(props) {
    const data = props.data;
    const [sportId, setSportId] = useState(data.sport[0].id);
    const [selections, setSelections] = useState({
        events: [],
        eventsSet: new Set()
    });
    const [widget, setWidget] = useState(null);

    useEffect(() => {
        function openTracker(e) {
            setTimeout(() =>
                setWidget(e.detail)
            );
        }
        window.addEventListener('xs_openTracker', openTracker);
        
        function moveTracker(e) {
            setTimeout(() =>
                setWidget(prev => {
                    return {
                        ...prev,
                        ...e.detail
                    };
                })
            );
        }
        window.addEventListener('xs_moveTracker', moveTracker);

        return () => {
            window.removeEventListener('xs_openTracker', openTracker);
            window.removeEventListener('xs_moveTracker', moveTracker);
        };
    }, []);

    function toggleWidget(type, event) {
        openModal(
            <LiveTrackerSelector type={type} event={event} />
        );
    }

    function add(e) {
        if (selections.eventsSet.size === 6) {
            openModal(
                <Modal title={'Info'}>
                    <InfoMessage text={'Non puoi aggiungere più di 6 eventi'} />
                </Modal>
            );

            return;
        }

        if (selections.eventsSet.has(e.uniqueId)) {
            return;
        }

        setSelections(prev => {
            prev.eventsSet.add(e.uniqueId);
            return {
                events: prev.events.concat(e),
                eventsSet: prev.eventsSet
            };
        });
    }

    function remove(e) {
        setSelections(prev => {
            prev.eventsSet.delete(e.uniqueId);
            return {
                events: prev.events.filter(event => event.uniqueId !== e.uniqueId),
                eventsSet: prev.eventsSet
            };
        });
    }

    function close() {
        if (widget.type === 'live-tracker') {
            window.dispatchEvent(new CustomEvent('xs-close-live-tracker'));
        } else {
            window.dispatchEvent(new CustomEvent('xs-close-streaming'));
        }
        setWidget(null);
    }

    let sport = null;
    
    try {
        sport = data.sportById[sportId] || data.sport[0];
    } catch (e) {
        return (
            <Loader error={true} />
        );
    }

    return (
        <WidgetContextProvider>
            <StreamingProvider>
                <div className="c_8" data-columns="1">
                    <div className="c_8_2" data-columns="1" data-gap>
                        <SportSelector sports={data.sport} selected={sportId} select={(sport) => setSportId(sport.id)} />
                        <EventsScroller>
                            {sport.categories.map(c =>
                                c.tournaments.map(t =>
                                    t.events.map(e => {
                                        if (selections.eventsSet.has(e.uniqueId)) {
                                            return null;
                                        }
                                        
                                        return (
                                            <ScrollerEvent key={e.uniqueId}
                                                        data={e}
                                                        add={(e) => add(e)}
                                            />
                                        );
                                    })
                                )
                            )}
                        </EventsScroller>
                        <div className="c_36_3">
                            {selections.events.map(e =>
                                <EventFetcher key={e.uniqueId}
                                            data={e}
                                            renderItem={(data, aggId, changeAgg) =>
                                                    <Event data={{...e, ...data}}
                                                        changeAgg={changeAgg}
                                                        close={() => remove(e)}
                                                        toggleWidget={toggleWidget}
                                                    />
                                            }
                                            renderTempItem={(isLoading, isError) =>
                                                <EventError data={e} close={() => remove(e)}>
                                                    <Loader error={isError} />
                                                </EventError>
                                            }
                                />
                            )}
                        </div>
                    </div>
                    {widget &&
                        <LiveTrackerContainer position={widget.position} move={toggleWidget} close={close}>
                            {widget.type === 'live-tracker' ?
                                <LiveTracker data={widget.event} />
                                :
                                <MultiliveStreaming data={widget.event} />
                            }
                        </LiveTrackerContainer>
                    }
                    <LiveResults portal="xs-search-results" />
                </div>
            </StreamingProvider>
        </WidgetContextProvider>
    );
}
